<template>
  <a-modal
    :title="!dataForm.id ? '新增' : '修改'"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-form
      :model="dataForm"
      ref="dataForm"
      @submit="dataFormSubmit()"
      label-width="80px"
    >
      <a-form-item label="媒体文件">
        <a-button type="primary">
          选择文件
          <input
            type="file"
            style="opacity: 0;height: 100%;position: absolute;left: 0;top: 0;"
            @change="onFileChange"
          />
          <input
            type="file"
            style="opacity: 0;height: 100%;position: absolute;left: 0;top: 0;"
            @change="onFileChange"
          />
        </a-button>
        <div>{{ dataForm.file.name }}</div>
      </a-form-item>
      <a-form-item label="媒体类型" prop="mediaType">
        <a-select
          v-model="dataForm.mediaType"
          placeholder="媒体类型"
          style="width:100%"
        >
          <a-select-option value="image"
            >图片（2M以内，支持PNG\JPEG\JPG\GIF）</a-select-option
          >
          <a-select-option value="video"
            >视频（10M以内，只支持MP4）</a-select-option
          >
          <a-select-option value="voice"
            >语音（2M、60s以内，支持AMR\MP3）</a-select-option
          >
          <a-select-option value="thumb">缩略图（64K以内JPG）</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="素材名称" prop="fileName">
        <a-input
          v-model="dataForm.fileName"
          placeholder="为便于管理建议按用途分类+素材内容命名"
          v-decorator="[
            'fileName',
            { rules: [{ required: true, message: '素材名称不能为空' }] }
          ]"
        ></a-input>
      </a-form-item>
    </a-form>
    <span slot="footer" class="dialog-footer">
      <a-button @click="visible = false">取消</a-button>
      <a-button
        type="primary"
        @click="dataFormSubmit()"
        :disabled="uploading"
        >{{ uploading ? '提交中...' : '提交' }}</a-button
      >
    </span>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      wechatAppId: '',
      visible: false,
      uploading: false,
      dataForm: {
        mediaId: '',
        file: '',
        fileName: '',
        mediaType: 'image'
      },
      dataRule: {
        fileName: [
          { required: true, message: '素材名称不能为空', trigger: 'blur' }
        ],
        mediaType: [
          { required: true, message: '素材类型不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleOk(e) {
      this.visible = false;
    },
    handleCancel(e) {
      this.visible = false;
    },
    init(fileType, appId) {
      if (fileType) this.dataForm.mediaType = fileType;
      this.visible = true;
      this.wechatAppId = appId;
    },
    // 表单提交
    dataFormSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.uploading = true;
          let form = new FormData();
          form.append('mediaId', this.dataForm.mediaId || '');
          form.append('file', this.dataForm.file);
          form.append('fileName', this.dataForm.fileName);
          form.append('mediaType', this.dataForm.mediaType);
          this.$http({
            url:
              process.env.VUE_APP_CMS_WECHAT +
              '/wechat/material/materialFileUpload',
            params: { appId: this.wechatAppId },
            method: 'post',
            data: form,
            headers: { 'Content-Type': 'multipart/form-data' }
          }).then(res => {
            if (res.success && res.code === 200) {
              this.$message.success('操作成功');
              this.visible = false;
              this.$emit('refreshDataList');
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    onFileChange(e) {
      let file = event.currentTarget.files[0];
      this.dataForm.file = file;
      this.dataForm.fileName = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      );
      let mediaType = file.type.substring(0, file.type.lastIndexOf('/'));
      if (mediaType == 'audio') mediaType = 'voice';
      this.dataForm.mediaType = mediaType;
    }
  }
};
</script>
